import { render, staticRenderFns } from "./selectContractLabel.vue?vue&type=template&id=01a24570&"
import script from "./selectContractLabel.vue?vue&type=script&lang=js&"
export * from "./selectContractLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports